export default "__VITE_ASSET__GuNdNRZT__"